export default __webpack_public_path__ + "static/media/blob.b6fe653d.svg";